exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#app{height:100%}.el-breadcrumb__inner.is-link,.el-breadcrumb__inner a{color:#666!important;font-weight:400!important;font-size:16px!important}.el-breadcrumb__separator{color:#666!important;font-weight:400!important;margin:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-077aafaf","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 957
// module chunks = 0